import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../App";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = (location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const finish = (path, state) => {
      window.history.replaceState(null, "", window.location.pathname);
      navigate(path, { replace: true, state });
    };

    if (!sessionId) {
      finish("/admin/login");
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/google/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        const { access_token, user } = res.data;
        loginWithToken(access_token, user);
        finish("/admin", { user });
      } catch (err) {
        finish("/admin/login", {
          googleError: err.response?.data?.detail || "Google sign-in failed. Please try again.",
        });
      }
    })();
  }, [location.hash, navigate, loginWithToken]);

  return (
    <div className="min-h-screen bg-[#0A2342] flex items-center justify-center">
      <div className="text-center">
        <div
          className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"
          data-testid="auth-callback-spinner"
        />
        <p className="text-slate-300 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
